<template>
  <div>
    <form-components @submitForm="submitForm">
      <template v-slot:content>
        <el-form-item label="代码类别" >
            <el-col :span="8">
              <el-input v-model="code.dmlb" ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="代码值">
            <el-col :span="8">
              <el-input v-model="code.dmz"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="代码名称">
            <el-col :span="8">
              <el-input v-model="code.dmmc"></el-input>
            </el-col>
          </el-form-item>
         
          <el-form-item label="排序">
            <el-col :span="8">
              <el-input v-model="code.sort"></el-input>
            </el-col>
          </el-form-item>
      </template>
    </form-components>
  </div>
</template>

<script>
import FormComponents from "@/components/form/FormComponents";
import CodeApi from '@/api/CodeApi'
import { navTo,queryParam } from "@/utils/NavigatorUtils";
export default {
  name: "SaveUserPassPage",
  props: {
    msg: String,
  },
  components: {
    FormComponents
  },
  data() {
    return {
      code:{
        id:0,
        dmlb:"",
        dmz:"",
        dmmc:"",
        sort:"",
      }
    }
  },
  created(){
    this.code = this.$route.params;
  },
  methods:{
    submitForm(){
      this.code.id>0?this.updateCodeById():this.addCode()
    },
    addCode(){
      CodeApi.saveCode(this.code).then((resp)=>{
        if(resp.state=="OK"){
          this.code={}
          this.$successMsg(resp.msg)
         
        }else{
          this.$errorMsg(resp.msg)
        }
      })
    },
    updateCodeById(){
      CodeApi.updateCode(this.code).then((resp)=>{
        if(resp.state=="OK"){
          this.user={}
          this.$successMsg(resp.msg);
           navTo(this,"/codeList")
        }else{
          this.$errorMsg(resp.msg)
        }
      })
    }
  }
};
</script>

